import React, { useMemo } from 'react';

import Icon from 'carbon-react/lib/components/icon';

import { FormattedMessage } from '@futrli/localisation';
import { ListingPageRowActionItem } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';
import { ProcessedUserRow } from '@futrli/views/processors/users/usersList';

import { useUsersActions } from '../../context/users-actions-context/users-actions-context';

interface UseUserActionItemsParams {
  user: ProcessedUserRow;
}

export const useUserActionItems = ({ user }: UseUserActionItemsParams): ListingPageRowActionItem[] => {
  const { handleDeleteUserClick, handleEditUserClick } = useUsersActions();

  return useMemo<ListingPageRowActionItem[]>(() => {
    const items: ListingPageRowActionItem[] = [];

    if (user.actions.edit) {
      items.push({
        label: (
          <>
            <Icon type="edit" fontSize="small" />
            <FormattedMessage id="common.edit" defaultMessage="Edit" />
          </>
        ),
        onClick: () => handleEditUserClick(user)
      });
    }

    if (user.actions.delete) {
      items.push({
        label: (
          <>
            <Icon type="delete" fontSize="small" />
            <FormattedMessage id="common.delete" defaultMessage="Delete" />
          </>
        ),
        onClick: () => handleDeleteUserClick(user),
        variant: 'danger'
      });
    }

    return items;
  }, [handleDeleteUserClick, handleEditUserClick, user]);
};
